import { CircularProgress, makeStyles, Theme } from "@material-ui/core";
import React, { FunctionComponent, memo } from "react";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

const Fallback: FunctionComponent<{
  color?: "inherit" | "primary" | "secondary";
}> = ({ color }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <CircularProgress color={color} size={60} />
    </div>
  );
};

export default memo(Fallback);
